import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { RiEyeOffLine } from 'react-icons/ri'

const BADGE_BG = '#fce7f3'
const BADGE_FG = '#be185d'

type Props = Readonly<{
  testId?: string
}>

/** Pink eye-slash chip identifying a Hidden Question Bank row (BFP-1070). */
export function QuestionBankHiddenBadge({ testId = 'question-bank-hidden-badge' }: Props) {
  return (
    <Box
      data-testid={testId}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        flexShrink: 0,
        bgcolor: BADGE_BG,
        color: BADGE_FG,
        borderRadius: '999px',
        px: '10px',
        py: '4px',
        height: 24,
        boxSizing: 'border-box',
      }}
    >
      <RiEyeOffLine size={14} aria-hidden />
      <Typography
        component="span"
        sx={{
          fontSize: '12px',
          lineHeight: '16px',
          fontWeight: 500,
          color: BADGE_FG,
        }}
      >
        Hidden
      </Typography>
    </Box>
  )
}
